import { useEffect } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import {
  expandWidget,
  selectSettings,
  selectComposed,
  selectOneChatSettings,
  selectOneChatComposed,
} from '@/features';
import { useAppDispatch, useAppSelector } from '@/store';
import { EXPERIMENTS, SS_FORCE_EXPAND_IN_VIEWER } from '@/constants';

import { useAppExperiments } from 'AiAssistantWidget/experiments';

export const useForcedExpandInViewer = () => {
  const dispatch = useAppDispatch();
  const { experiments } = useAppExperiments();

  const { isEditor, isMobile } = useEnvironment();

  const neverLoadedLegacySettings = useAppSelector(selectSettings.neverLoaded);
  const neverLoadedOneChatSettings = useAppSelector(
    selectOneChatSettings.neverLoaded,
  );
  const neverLoadedSettings = experiments.enabled(EXPERIMENTS.ONE_CHAT)
    ? neverLoadedOneChatSettings
    : neverLoadedLegacySettings;

  const shouldAutoOpenLegacyWidget = useAppSelector(
    selectComposed.shouldAutoOpenWidget,
  );
  const shouldAutoOpenOneChatWidget = useAppSelector(
    selectOneChatComposed.shouldAutoOpenWidget,
  );
  const shouldAutoOpenWidget = experiments.enabled(EXPERIMENTS.ONE_CHAT)
    ? shouldAutoOpenOneChatWidget
    : shouldAutoOpenLegacyWidget;

  useEffect(() => {
    if (isEditor || neverLoadedSettings || isMobile) {
      return;
    }

    if (
      shouldAutoOpenWidget &&
      !JSON.parse(sessionStorage.getItem(SS_FORCE_EXPAND_IN_VIEWER) ?? 'false')
    ) {
      dispatch(expandWidget());
      sessionStorage.setItem(SS_FORCE_EXPAND_IN_VIEWER, 'true');
    }
  }, [isEditor, neverLoadedSettings, shouldAutoOpenWidget, isMobile, dispatch]);
};
